'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useEffect, useMemo, useState } from 'react'
import { CareAndShareContainer } from './container'

export const CareShareCollaboration = () => {
  const t = useTranslations()

  const timelineKeys = useMemo(
    () => [
      'care_and_share_hardcode.collaboration.timeline.y2023',
      'care_and_share_hardcode.collaboration.timeline.y2024',
      'care_and_share_hardcode.collaboration.timeline.y2025',
    ],
    []
  )

  const yearKeys = useMemo(
    () => [
      'care_and_share_hardcode.collaboration.year_text.y2023',
      'care_and_share_hardcode.collaboration.year_text.y2024',
      'care_and_share_hardcode.collaboration.year_text.y2025',
    ],
    []
  )

  const descriptionKeys = useMemo(
    () => [
      'care_and_share_hardcode.collaboration.description_text.y2023',
      'care_and_share_hardcode.collaboration.description_text.y2024',
      'care_and_share_hardcode.collaboration.description_text.y2025',
    ],
    []
  )

  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % timelineKeys.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [timelineKeys.length])

  return (
    <CareAndShareContainer className='!py-0'>
      <div className='relative grid grid-cols-1 items-center gap-8 rounded-xl bg-neutral-800 px-5 py-10 text-white md:grid-cols-12 md:rounded-3xl md:px-15 md:py-20'>
        <Image
          src={ImageHelper.getImageUrl('/image/August2025/mceclip0_86.png')}
          alt='Operation Smile'
          width={100}
          height={139}
          className='absolute left-0 top-0 h-full w-auto object-contain'
        />
        <div className='col-span-1 space-y-4 md:col-span-5'>
          <div className='font-criteria text-7xl font-extrabold'>
            {t(yearKeys[activeIndex])}
          </div>
          <div className='font-criteria text-3xl font-semibold uppercase'>
            {t('care_and_share_hardcode.collaboration.title')}
          </div>
          <div className='min-h-[3rem] md:min-h-[4rem]'>
            {t(descriptionKeys[activeIndex])}
          </div>
        </div>
        <div className='col-span-1 grid h-fit grid-cols-2 items-center gap-8 md:col-span-7'>
          <div className='flex h-full items-center justify-center rounded-2xl bg-white px-5 py-4 md:px-17 md:py-9'>
            <Image
              src={ImageHelper.getImageUrl('/image/August2025/mceclip2_71.png')}
              alt='Operation Smile'
              width={100}
              height={139}
              className='w-auto object-contain'
            />
          </div>
          <div className='flex h-full items-center justify-center rounded-2xl bg-white px-5 py-4 md:px-17 md:py-9'>
            <Image
              src={ImageHelper.getImageUrl('/image/August2025/mceclip4_33.png')}
              alt='Operation Smile'
              width={100}
              height={79}
              className='w-auto object-contain'
            />
          </div>
        </div>
      </div>
    </CareAndShareContainer>
  )
}
